/**
 * TanStack Query hooks for UAS Audit Logs
 */

import { useQuery } from '@tanstack/react-query'
import { fetchUASAuditLogs, fetchSubjectAuditLogs } from '@/lib/uas-api'
import type { AuditLogQueryParams } from '@/types/uas'

export const uasAuditKeys = {
  all: ['uas', 'audit-logs'] as const,
  lists: () => [...uasAuditKeys.all, 'list'] as const,
  list: (params: AuditLogQueryParams) => [...uasAuditKeys.lists(), params] as const,
  subject: (subjectId: string) => [...uasAuditKeys.all, 'subject', subjectId] as const,
}

export function useUASAuditLogs(params: AuditLogQueryParams = {}) {
  return useQuery({
    queryKey: uasAuditKeys.list(params),
    queryFn: () => fetchUASAuditLogs(params),
    placeholderData: (previousData) => previousData,
    staleTime: 15 * 1000,
  })
}

export function useSubjectAuditLogs(subjectId: string | undefined) {
  return useQuery({
    queryKey: subjectId
      ? uasAuditKeys.subject(subjectId)
      : ['uas', 'audit-logs', 'subject', 'disabled'],
    queryFn: () => {
      if (!subjectId) return Promise.reject(new Error('Subject ID is required'))
      return fetchSubjectAuditLogs(subjectId)
    },
    enabled: !!subjectId,
    staleTime: 10 * 1000,
  })
}
